import { useIntl } from "react-intl";
import type { Control } from "react-hook-form";

import type { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import TextField from "./TextField";

export interface LocationCommentsFieldProps {
  control: Control<PostMeetingFormWithSummary>;
}

export default function LocationCommentsField({
  control,
}: LocationCommentsFieldProps) {
  const { $t } = useIntl();

  return (
    <TextField
      name="locationComments"
      label={$t(FIELD_LABELS.locationComments)}
      control={control}
    />
  );
}
